var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.items,"loading":_vm.loading,"headers":_vm.headers,"no-data-text":"No Raw Materials linked yet...","dense":""},scopedSlots:_vm._u([{key:"item.quantity",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.quantity)+" "+_vm._s(item.units)+" ")]}},{key:"item.rawmaterial.barcode",fn:function(ref){
var item = ref.item;
return [_c('RawMaterialChip',{attrs:{"rawmaterial":item.rawmaterial}})]}},(_vm.isDetailed)?{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('BatchRawOriginEdit',{attrs:{"batchid":_vm.batchid,"materialid":_vm.materialid,"instance":item}}),_c('BatchRawOriginDelete',{attrs:{"id":item.id}})]}}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }